import React from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative min-h-screen bg-gradient-to-br from-blue-600 via-blue-700 to-blue-800 flex items-center">
        <div className="container mx-auto px-4 py-20">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div className="text-white space-y-8">
              <div className="inline-flex items-center bg-white/10 backdrop-blur-sm rounded-full px-6 py-3 mb-6 border border-white/20">
                <div className="w-3 h-3 bg-green-400 rounded-full mr-3 animate-pulse"></div>
                <span className="text-sm font-medium">Live in Myanmar - 99.9% Uptime</span>
              </div>
              <div className="space-y-6">
                <h1 className="text-5xl md:text-7xl font-black leading-tight">
                  <span className="bg-gradient-to-r from-white to-blue-100 bg-clip-text text-transparent">
                    Instant
                  </span>
                  <br />
                  <span className="text-white/95">Connectivity</span>
                </h1>
                <p className="text-xl md:text-2xl text-blue-100 leading-relaxed max-w-lg">
                  Revolutionary eSIM technology. Zero physical cards. 
                  <span className="text-white font-semibold"> Activate in 30 seconds.</span>
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link 
                  to="/plans"
                  className="group bg-white text-blue-600 hover:bg-blue-50 font-bold py-5 px-10 rounded-2xl text-lg transition-all duration-300 text-center shadow-2xl hover:scale-105"
                >
                  Explore Plans
                </Link>
                <Link 
                  to="/auth"
                  className="border-2 border-white/40 hover:bg-white/10 text-white font-bold py-5 px-10 rounded-2xl text-lg transition-all duration-300 text-center backdrop-blur-sm"
                >
                  Start Free Trial
                </Link>
              </div>
              <div className="flex items-center space-x-8 pt-4">
                <div className="text-center">
                  <div className="text-2xl font-bold text-white">50K+</div>
                  <div className="text-sm text-blue-200">Active Users</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-white">99.9%</div>
                  <div className="text-sm text-blue-200">Uptime</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-white">24/7</div>
                  <div className="text-sm text-blue-200">Support</div>
                </div>
              </div>
            </div>
            <div className="relative">
              <div className="bg-white/10 backdrop-blur-xl rounded-3xl p-8 border border-white/20 shadow-2xl">
                <div className="bg-white rounded-2xl p-8 shadow-2xl">
                  <div className="flex items-center justify-between mb-6">
                    <div className="flex items-center space-x-2">
                      <div className="w-3 h-3 bg-red-500 rounded-full"></div>
                      <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
                      <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                    </div>
                    <div className="flex items-center space-x-2">
                      <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                      <span className="text-xs text-gray-500 font-medium">Live Pricing</span>
                    </div>
                  </div>
                  <div className="space-y-4">
                    <div className="flex items-center justify-between p-4 bg-gradient-to-r from-gray-50 to-gray-100 rounded-xl hover:from-blue-50 hover:to-blue-100 transition-all duration-300">
                      <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                          <div className="w-5 h-5 bg-blue-600 rounded-md"></div>
                        </div>
                        <div>
                          <span className="font-semibold text-gray-900">Tourist</span>
                          <div className="text-xs text-gray-500">7 days - 5GB</div>
                        </div>
                      </div>
                      <div className="text-right">
                        <span className="text-blue-600 font-bold text-lg">15K</span>
                        <div className="text-xs text-gray-500">MMK</div>
                      </div>
                    </div>
                    <div className="flex items-center justify-between p-4 bg-gradient-to-r from-blue-50 to-blue-100 rounded-xl border-2 border-blue-200 shadow-lg">
                      <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
                          <div className="w-5 h-5 bg-white rounded-md"></div>
                        </div>
                        <div>
                          <div className="flex items-center space-x-2">
                            <span className="font-semibold text-gray-900">Business</span>
                            <span className="bg-blue-600 text-white text-xs px-2 py-1 rounded-full">Popular</span>
                          </div>
                          <div className="text-xs text-gray-500">30 days - 20GB</div>
                        </div>
                      </div>
                      <div className="text-right">
                        <span className="text-blue-600 font-bold text-lg">35K</span>
                        <div className="text-xs text-gray-500">MMK</div>
                      </div>
                    </div>
                    <div className="flex items-center justify-between p-4 bg-gradient-to-r from-gray-50 to-gray-100 rounded-xl hover:from-purple-50 hover:to-purple-100 transition-all duration-300">
                      <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
                          <div className="w-5 h-5 bg-purple-600 rounded-md"></div>
                        </div>
                        <div>
                          <span className="font-semibold text-gray-900">Extended</span>
                          <div className="text-xs text-gray-500">90 days - 50GB</div>
                        </div>
                      </div>
                      <div className="text-right">
                        <span className="text-purple-600 font-bold text-lg">65K</span>
                        <div className="text-xs text-gray-500">MMK</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-24 bg-gradient-to-b from-white to-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-20">
            <h2 className="text-4xl md:text-6xl font-black text-gray-900 mb-6">
              Why Choose eSIM
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Experience the future of mobile connectivity
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white p-8 rounded-3xl border hover:shadow-2xl transition-all duration-500 hover:-translate-y-2">
              <div className="w-16 h-16 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-2xl flex items-center justify-center mb-6 shadow-lg">
                <span className="text-2xl">⚡</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Lightning Fast</h3>
              <p className="text-gray-600">Activate in under 30 seconds</p>
            </div>
            
            <div className="bg-white p-8 rounded-3xl border hover:shadow-2xl transition-all duration-500 hover:-translate-y-2">
              <div className="w-16 h-16 bg-gradient-to-r from-green-400 to-blue-500 rounded-2xl flex items-center justify-center mb-6 shadow-lg">
                <span className="text-2xl">🌍</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Global Network</h3>
              <p className="text-gray-600">200+ countries, 1000+ carriers</p>
            </div>
            
            <div className="bg-white p-8 rounded-3xl border hover:shadow-2xl transition-all duration-500 hover:-translate-y-2">
              <div className="w-16 h-16 bg-gradient-to-r from-purple-400 to-pink-500 rounded-2xl flex items-center justify-center mb-6 shadow-lg">
                <span className="text-2xl">🔒</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Military Grade</h3>
              <p className="text-gray-600">End-to-end encryption</p>
            </div>
            
            <div className="bg-white p-8 rounded-3xl border hover:shadow-2xl transition-all duration-500 hover:-translate-y-2">
              <div className="w-16 h-16 bg-gradient-to-r from-blue-400 to-indigo-500 rounded-2xl flex items-center justify-center mb-6 shadow-lg">
                <span className="text-2xl">💬</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Expert Support</h3>
              <p className="text-gray-600">24/7 multilingual assistance</p>
            </div>
          </div>
        </div>
      </section>

      {/* Plans Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Plans for every journey
            </h2>
            <p className="text-lg text-gray-600">
              Choose the perfect data plan for your Myanmar adventure
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="text-center">
                <h3 className="text-xl font-bold text-gray-900 mb-2">Tourist</h3>
                <div className="mb-4">
                  <span className="text-3xl font-bold text-gray-900">15,000</span>
                  <span className="text-gray-600 ml-1">MMK</span>
                </div>
                <div className="bg-gray-50 rounded-lg p-4 mb-6">
                  <div className="text-2xl font-bold text-blue-600 mb-1">5GB</div>
                  <div className="text-sm text-gray-600">7 days</div>
                </div>
                <button className="w-full py-3 px-6 rounded-xl font-semibold bg-gray-100 hover:bg-gray-200 text-gray-900 transition-all duration-300">
                  Get Started
                </button>
              </div>
            </div>

            <div className="relative bg-white rounded-2xl p-6 ring-2 ring-blue-500 shadow-xl scale-105">
              <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
                <span className="bg-blue-600 text-white px-4 py-1 rounded-full text-sm font-medium">
                  Most Popular
                </span>
              </div>
              <div className="text-center">
                <h3 className="text-xl font-bold text-gray-900 mb-2">Business</h3>
                <div className="mb-4">
                  <span className="text-3xl font-bold text-gray-900">35,000</span>
                  <span className="text-gray-600 ml-1">MMK</span>
                </div>
                <div className="bg-gray-50 rounded-lg p-4 mb-6">
                  <div className="text-2xl font-bold text-blue-600 mb-1">20GB</div>
                  <div className="text-sm text-gray-600">30 days</div>
                </div>
                <button className="w-full py-3 px-6 rounded-xl font-semibold bg-blue-600 hover:bg-blue-700 text-white shadow-lg transition-all duration-300">
                  Get Started
                </button>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="text-center">
                <h3 className="text-xl font-bold text-gray-900 mb-2">Extended</h3>
                <div className="mb-4">
                  <span className="text-3xl font-bold text-gray-900">65,000</span>
                  <span className="text-gray-600 ml-1">MMK</span>
                </div>
                <div className="bg-gray-50 rounded-lg p-4 mb-6">
                  <div className="text-2xl font-bold text-blue-600 mb-1">50GB</div>
                  <div className="text-sm text-gray-600">90 days</div>
                </div>
                <button className="w-full py-3 px-6 rounded-xl font-semibold bg-gray-100 hover:bg-gray-200 text-gray-900 transition-all duration-300">
                  Get Started
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default LandingPage;